module.exports = __webpack_public_path__ + "img/luckydraw_campaign_2024_03_14.0fedcd7c.jpg";